import React, { useEffect } from "react";
import {
  KDialog,
  KImagesUploader,
  KTextInput,
  KSelect,
} from "@kyburz/kdesign-system";
import { useSelector } from "react-redux";
import useSafeSetState from "../../hooks/useSafeSetState";
import { getIncidentPhotoUrl } from "../../apiCalls/imageUploads/incidentsUploads";
import { DAMAGE_TYPES } from "../constants/incidents";
import { capitalize } from "../../utils/utils";
import { Damage } from "../../interfaces/IncidentInterface";
import { RootStateInterface } from "../../interfaces/ReduxInterface";

interface Props {
  open: boolean;
  cancel: () => void;
  save: (value) => void;
  initDamage?: Damage;
}

const DamagePopup = ({ open, cancel, save, initDamage }: Props) => {
  const currentCustomer = useSelector(
    (state: RootStateInterface) => state.customer.currentCustomer,
  );
  const damageTypeOptions = Object.values(DAMAGE_TYPES).map((t) => ({
    label: capitalize(t),
    id: t,
  }));

  const getPhotos = (photos) =>
    photos.map((p) =>
      p.url
        ? p
        : {
            image: p,
            url: p,
          },
    );

  const initialState = {
    damage_type: initDamage?.damage_type || DAMAGE_TYPES.DAMAGE,
    description: initDamage?.description || "",
    photos: initDamage?.photos || [],
    image: "",
  };
  const [{ damage_type, description, photos }, setState] = useSafeSetState(
    initialState,
  );

  useEffect(() => {
    setState({
      damage_type: initDamage?.damage_type || DAMAGE_TYPES.DAMAGE,
      description: initDamage?.description || "",
      photos: initDamage?.photos ? getPhotos(initDamage?.photos) : [],
    });
  }, [initDamage]);

  const updateDamageDescription = (e) =>
    setState({
      description: e.target.value,
    });

  const updateDamageType = (data) =>
    setState({
      damage_type: data.id,
    });

  const handleSaveDamage = () => {
    save({
      ...initDamage,
      description,
      damage_type,
      photos,
    });
    setState({ ...initialState });
  };

  const updatePhotos = (newPhotos) => setState({ photos: newPhotos });

  return (
    <KDialog
      title="Save damage"
      open={open}
      size="md"
      primaryCTAonClick={handleSaveDamage}
      primaryCTAText="Save"
      secondaryCTAonClick={cancel}
      secondaryCTAText="Cancel"
    >
      <KSelect
        label="Damage type"
        value={capitalize(damage_type)}
        onSelect={updateDamageType}
        elements={damageTypeOptions}
        height={105}
      />
      <KTextInput
        label="Description"
        value={description}
        onChange={updateDamageDescription}
        multiline={true}
        width="100%"
      />
      <KImagesUploader
        title="Upload Image"
        uploadText="Choose file..."
        helperText="Allowed files are .PNG, .JPG and .JPEG"
        width={400}
        height={400}
        fetchUrl={getIncidentPhotoUrl}
        uploadUrl={`${currentCustomer.shortname}/incidents/upload_photo`}
        previewStyle={{}}
        uploadPosition="bottom"
        setImages={updatePhotos}
        initialImages={photos}
      />
    </KDialog>
  );
};

export default DamagePopup;
